<template>
    <v-card class="d-flex align-center justify-center summary-card" min-width="40vw" outlined>
        <div style="width: 100% !important;" ref="summary-img">
            <v-card-title style="background-color: #fff75f;" class="text-center">
                <v-list-item class="d-flex align-center justify-start">
                    <v-list-item-title>
                        <h2>{{ period }}</h2>
                        <p class="mb-0">{{ $t('from') }} {{ fromDate.getDate() }}-{{ months[fromDate.getMonth()] }} {{ $t('to') }} {{ toDate.getDate() }}-{{ months[toDate.getMonth()] }}</p>
                    </v-list-item-title>
                    <v-spacer/>
                    <v-list-item-action><v-icon class="icon" @click="close" icon>fa-times</v-icon></v-list-item-action>
                </v-list-item>
            </v-card-title>
            <v-card-text class="px- pt-5" >
                <v-container v-if="numberOfTrades !== -1" fluid>
                    <v-row>
                        <v-col cols="3" class="d-flex justify-center">
                            <div>
                                <h1 :class="(netProfit > 0)? 'd-flex justify-center big-positive' : 'd-flex justify-center big-negative'">{{ getNumber(netProfit) }}</h1>
                                <h4 class="d-flex justify-center text-center">{{ $t('metrics.netProfit') }}</h4>
                            </div>
                        </v-col>
                        <v-col cols="3" class="d-flex justify-center">
                            <div>
                                <h1 class="d-flex justify-center big-number">{{ (winRate.toFixed(1) * 1).toString() }}%</h1>
                                <h4 class="d-flex justify-center text-center">{{ $t('metrics.winRate') }}</h4>
                            </div>
                        </v-col>
                        <v-col cols="3" class="d-flex justify-center">
                            <div>
                                <h1 class="d-flex justify-center big-number">{{ getNumber(profitFactor) }}</h1>
                                <h4 class="d-flex justify-center text-center">{{ $t('metrics.profitFactor') }}</h4>
                            </div>
                        </v-col>
                        <v-col cols="3" class="d-flex justify-center">
                            <div>
                                <h1 class="d-flex justify-center big-number">{{ numberOfTrades }}</h1>
                                <h4 class="d-flex justify-center text-center">{{ $t('metrics.trades') }}</h4>
                            </div>
                        </v-col>
                    </v-row>
                    <v-divider dark class="mb-2 mt-5"/>
                    <v-row class="d-flex justify-center">
                        <v-col cols="4" class="d-flex justify-center">
                            <div>
                                <h1 class="d-flex justify-center big-positive">{{ getNumber(bestTrade) }}</h1>
                                <h4 class="d-flex justify-center text-center">{{ $t('metrics.bestTrade') }}</h4>
                            </div>
                        </v-col>
                        <v-col cols="4" class="d-flex justify-center">
                            <div>
                                <h1 class="d-flex justify-center big-number">{{ getNumber(avgProfit) }}</h1>
                                <h4 class="d-flex justify-center text-center">{{ $t('metrics.avgProfit') }}</h4>
                            </div>
                        </v-col>
                        <v-col cols="4" class="d-flex justify-center">
                            <div>
                                <h1 class="d-flex justify-center big-negative">{{ getNumber(worstTrade) }}</h1>
                                <h4 class="d-flex justify-center text-center">{{ $t('metrics.worstTrade') }}</h4>
                            </div>
                        </v-col>
                    </v-row>
                    <p class="d-flex align-center justify-center text-center mt-7">
                      {{ $t('shareInvite') }} <v-chip class="ml-2" @click="downloadImage" color="grey" small>{{ $t('btnDownload') }}</v-chip>
                    </p>
                </v-container>
                <div v-if="numberOfTrades === -1" class="mt-5 mb-10">
                    <h1 class="d-flex justify-center no-trades">:(</h1>
                    <br>
                    <h3 class="d-flex justify-center">{{ $t('noTrades.title') }}</h3>
                  <v-row class="mt-5" align="center" justify="center">
                    <v-btn @click="goToTrades">{{ $t('noTrades.callToAction') }}</v-btn>
                  </v-row>
                </div>
            </v-card-text>
        </div>
    </v-card>
</template>

<script>
    //import { saveAs } from 'file-saver';
    //import domtoimage from 'dom-to-image';
    import html2canvas from 'html2canvas';
    import Repository from '../repositories/journal';
    export default {
        name: "PeriodSummary",
        props: {
            period: String,
            fromDate: Date,
            toDate: Date,
        },
        data() {
            return {
                months: [],
                trades: [],

                // Stats
                netProfit: 0,
                winRate: 0,
                profitFactor: 0,
                numberOfTrades: 0,
                avgProfit: 0,
                bestTrade: 0,
                worstTrade: 0,
            };
        },
        async mounted() {
            await this.getMonths();
            await this.retrieveTrades();
            await this.getSummary();
        },
        methods: {
            goToTrades() {
              this.$router.push('/book');
            },
            getMonths() {
              this.months = [
                this.$t('months.jan'),
                this.$t('months.feb'),
                this.$t('months.mar'),
                this.$t('months.apr'),
                this.$t('months.may'),
                this.$t('months.jun'),
                this.$t('months.jul'),
                this.$t('months.aug'),
                this.$t('months.sep'),
                this.$t('months.oct'),
                this.$t('months.nov'),
                this.$t('months.dec'),
              ];
            },
            async retrieveTrades() {
                let fullFromDate = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth(), this.fromDate.getDate(), 0, 0);
                let fullToDate = new Date(this.toDate.getFullYear(), this.toDate.getMonth(), this.toDate.getDate(), 0, 0);
                fullToDate.setDate(fullToDate.getDate() + 1);
                let filter = {
                    fromDate: fullFromDate,
                    toDate: fullToDate,
                    side: 'All',
                    mood: 'All',
                    asset: 'All',
                    brokerAccount: 'All',
                    result: 'All',
                    strategy: 'All',
                };

                await Repository.filteredTradesOfUserGet(filter).then((response) => {
                    if(response.status < 400)
                        this.trades = response.data.content;
                });
            },
            getSummary() {
                if (this.trades.length === 0) {
                    this.numberOfTrades = -1;
                    return;
                }

                this.numberOfTrades = this.trades.length;
                this.netProfit = 0;
                this.winRate = 0;
                this.bestTrade = 0;
                this.worstTrade = 0;
                this.avgProfit = 0;
                this.profitFactor = 0;
                let negativeTrades = 0;

                this.trades.forEach((trade) => {
                    let netProfit = trade.netProfit
                    this.netProfit += netProfit;
                    if(netProfit > 0) {
                        this.winRate++;
                        this.profitFactor += netProfit;
                        this.bestTrade = Math.max(this.bestTrade, netProfit);
                    }
                    else {
                        negativeTrades += netProfit;
                        this.worstTrade = Math.min(this.worstTrade, netProfit);
                    }
                });

                this.avgProfit = (negativeTrades + this.profitFactor) / this.numberOfTrades;
                this.winRate /= this.numberOfTrades;
                this.winRate *= 100;
                this.profitFactor /= Math.abs(negativeTrades);
                
            },
            getNumber(number) {
              return (number > 1000 || number < -1000)? `${(number/1000).toFixed(2)}k` : (number.toFixed(2) * 1).toString();
            },
            async downloadImage() {
              let el = this.$refs["summary-img"];
              let options = { type: "dataURL", };
              let printCanvas = await html2canvas(el, options);

              let link = document.createElement("a");
              link.setAttribute(`download`, `Weekly Summary.png`);
              link.setAttribute( "href", printCanvas.toDataURL("image/png").replace("image/png", "image/octet-stream"));
              link.click();
            },
            close() {
                this.$emit('closeSummary');
            },
        },
    }
</script>



<style scoped>
    .summary-card {
        border: 0 !important;
    }
    .no-trades {
        color: #FFFFFF;
        font-size: 70px;
    }
    .big-number {
        color: #F8F8F8;
        font-size: 49px;
    }
    .big-positive {
        color: #00a575;
        font-size: 49px;
    }
    .big-negative {
        color: #ff6b55;
        font-size: 49px;
    }
</style>
